import React, {useEffect, useState} from 'react';
import {GET, UPDATE} from "../Api/RfmSetting/RfmSettingApi"
import {useCookies} from "react-cookie";
import Header from "../Header/Header";
import {Drawer} from "@material-ui/core";
import RightMenu from "../RightMenu";
import {RfmSettingRowBuilder} from "./RfmSettingRowBuilder";
import Breadcrumb from '../Breadcrumb/Breadcrumb';

export default function RfmSetting() {
    const [cookies, setCookie, removeCookie] = useCookies();
    const [state, setState] = React.useState({right: false});
    const [alert, setAlert]=useState(false);
    const [settings, setSettings] = useState(
        {
            score1_r_from: 0,
            score1_f_from: 0,
            score1_m_from: 0,
            score2_r_from: 0,
            score2_f_from: 0,
            score2_m_from: 0,
            score2_r_to: 0,
            score2_f_to: 0,
            score2_m_to: 0,
            score3_r_from: 0,
            score3_f_from: 0,
            score3_m_from: 0,
            score3_r_to: 0,
            score3_f_to: 0,
            score3_m_to: 0,
            score4_r_from: 0,
            score4_f_from: 0,
            score4_m_from: 0,
            score4_r_to: 0,
            score4_f_to: 0,
            score4_m_to: 0,
            score5_r_to: 0,
            score5_f_to: 0,
            score5_m_to: 0
        }
    );

    const changeHandler = (e) => {
        let type = e.target.attributes.type.value;
        let value = e.target.value;
        setSettings((prevState) =>
            ({...prevState, [type]: value}));
        setAlert(0);
    }
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({...state, [anchor]: open});
    };

    useEffect(() => {
        GET(cookies.user_server_token).then((res) => {
            setSettings(res)
        });
    }, []);
    return (
        <>
            {console.log("SEt", settings)}
            <Breadcrumb title={" تنظیمات RFM "} />

            {alert && <div className={"alert alert-primary text-center"}>
                عملیات با موفقیت انجام شد
            </div>}
            <div className="container ltr mt-5 ">
                <table className="table table-striped">
                    <thead>
                    <tr className={"bg-danger"}>
                        <th scope="col" className={"text-white"}>Score</th>
                        <th scope="col" className={"text-white"}>R</th>
                        <th scope="col" className={"text-white"}>F</th>
                        <th scope="col" className={"text-white"}>M</th>
                    </tr>
                    </thead>
                    <tbody>
                    <RfmSettingRowBuilder setting={settings} change={changeHandler}/>
                    </tbody>
                </table>
                <div className="btn btn-block btn-danger text-white"
                     onClick={() => {
                         UPDATE(settings, cookies.user_server_token);
                         setAlert(1);
                     }}
                >
                    ویرایش
                </div>

            </div>
        </>
    )
        ;
}
